(function () {
  'use strict';

  function bind(el) {
    if (!el || el.dataset.eventNavBound === '1') return;
    const cover = el.querySelector('a.event-card__link--cover, a.event-featured__link--cover');
    if (!cover || !cover.getAttribute('href')) return;
    el.dataset.eventNavBound = '1';

    el.addEventListener(
      'click',
      function (e) {
        if (!(e instanceof MouseEvent)) return;
        if (e.button !== 0) return;

        if (el.classList.contains('event-card--clickable')) {
          if (e.target.closest('.event-card__footer-actions')) return;
        }
        if (el.classList.contains('event-featured--clickable')) {
          if (e.target.closest('.event-featured__content a.button')) return;
        }

        const url = cover.getAttribute('href');
        if (!url) return;

        e.preventDefault();
        e.stopPropagation();

        const forceNewTab = e.metaKey || e.ctrlKey || cover.getAttribute('target') === '_blank';
        if (forceNewTab) {
          window.open(url, '_blank', 'noopener,noreferrer');
        } else {
          window.location.assign(url);
        }
      },
      true
    );
  }

  function init(root) {
    const scope = root && root.nodeType === 1 ? root : document;
    scope.querySelectorAll('.event-card--clickable, .event-featured--clickable').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e && e.target) init(e.target);
  });

  document.addEventListener('uprunning:events-featured-replaced', function (e) {
    const root = e && e.detail && e.detail.root;
    if (root && root.nodeType === 1) init(root);
  });
})();
